// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AccountSettingsGreifState } from "@store/Framework/Store/Greif/Pages/AccountSettings/AccountSettingsState";
import { Draft } from "immer";

const initialState: AccountSettingsGreifState = {};

const actions = {
    "Greif/PagesReducer/AccountSettings/SetAdditionalAccountSettingsValues": (
        draft: Draft<AccountSettingsGreifState>,
        action: AccountSettingsGreifState,
    ) => {
        draft.followNewPrice = action.followNewPrice;
        draft.followNewFeature = action.followNewFeature;
        draft.followNewTec = action.followNewTec;
        draft.followUpcomingShipment = action.followUpcomingShipment;
        draft.followOrderShipped = action.followOrderShipped;
        draft.followOrderPickup = action.followOrderPickup;
        draft.followOrderChange = action.followOrderChange;
        draft.language = action.language;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type GreifAccountSettingsPageReducer = Parameters<typeof reducer>[1];
export default reducer;
